import gql from 'graphql-tag';

export const DELETE_CALENDAR_VIEW = gql`
  mutation SaveCalendarViewConfiguration($input: DeleteCalendarViewInput!) {
    dealActivity {
      result: deleteCalendarView(input: $input) {
        error
        success
        entity {
          id
          name
          color
          owner {
            id
            fullName
          }
        }
      }
    }
  }
`;
